import { AppHeader } from '@ace-clublabs/shared-component-library';

const Header: React.FC = () => {
  return <AppHeader id="ace-header" displayShadow={false} />;
};

export default Header;
